/**
 * AddModuleSettingsCtrl controller
 * Add/edit Module Settings
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

/**
 * AddModuleSettingsCtrl controller
 *
 * @class AddModuleSettingsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @ngdoc controller
 * @name mwApp/addModule.controller:AddModuleSettingsCtrl
 */
/* @ngInject */

export default function AddModuleSettingsCtrl ($scope, $state, $location, $uibModal, NetworkRow, alertLiteSvc, scope, module, pckg, assignedItems) {
  const vm = this
  vm.identifierFieldLength = 11
  vm.assignedItems = assignedItems
  vm.cashedAllRows = {}
  vm.disabledByRows = true

  vm.iconRequiredError = function () {
    return !vm.module.iconName
  }

  vm.module = module

  vm.icons = ['cup', 'ball', 'lock', 'music', 'podcast', 'food', 'hat', 'game', 'rocket', 'puzzle', 'cubes', 'hearts']
  // For custom modules (NOT CHILDREN'S), exclude robot and toys icons
  if (vm.module.moduleType === 'KIDS') {
    vm.icons.push('robot', 'toys')
  }

  vm.disabledEditMain = module.title === 'Home'

  vm.deleteModuleMassage = 'Are you sure you want to delete Module permanently?'

  if (vm.module.moduleType === 'KIDS') {
    vm.deleteModuleMassage = 'Deleting this module will immediately remove it from Client Apps. Subscribers will be required to change the Kids Profile Type for their existing Kids Profiles.'
  }

  vm.isNew = module._isNew()
  if (!vm.isNew) {
    assignedItems.title = assignedItems.title.filter(t => t !== vm.module.title)
    assignedItems.identifier = assignedItems.identifier.filter(i => i !== vm.module.identifier)
    assignedItems.iconName = assignedItems.iconName.filter(icon => icon !== vm.module.iconName)
  }

  vm.predefinedTitles = ['My List', 'Settings', 'Search']
  vm.predefinedIdentifiers = ['my_list', 'settings', 'search']

  vm.postersIsOpen = true

  vm.onTitleBlur = function () {
    if (!vm.isNew) return
    if (vm.module?.identifier || !vm.module?.title) return

    vm.module.identifier =
      vm.module?.title
        .toLowerCase()
        .substring(0, vm.identifierFieldLength)
        .replaceAll(' ', '_')
  }

  scope.selectedRow = vm.selectedRow = {}
  vm.selectedRow = vm.module.rows[0]
  angular.copy(vm.module.rows).forEach(row => { vm.cashedAllRows[row.$uuid] = row })

  const params = { moduleId: vm.module.id, count: 1000, page: 0 }

  if (vm.module.moduleType === 'KIDS') { params.allowedForKids = true }

  vm.availableRows = []

  const getAvailableRows = function () {
    NetworkRow.getAvailableRows(pckg.id, params).then(res => {
      vm.availableRows = vm.availableRows.concat(res.content)

      if (!res.last) {
        params.page++
        getAvailableRows()
      } else {
        vm.availableRows.forEach(row => {
          row.$uuid = Math.floor(Math.random() * 1000000)
          while (vm.availableRows.filter(ar => ar.$uuid === row.$uuid).length > 1) {
            row.$uuid = Math.floor(Math.random() * 1000000)
          }
        })
        angular.copy(vm.availableRows).forEach(row => { vm.cashedAllRows[row.$uuid] = row })
      }
    })
  }
  getAvailableRows()

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @function
   */
  vm.addRows = function () {
    const initialAssigned = angular.copy(vm.module.rows)
    const initialAvailable = angular.copy(vm.availableRows)
    $uibModal.open({
      templateUrl: 'components/packages/views/addRows.html',
      controller: 'AddRowsCtrl as vm',
      animation: false,
      size: 'xl',
      resolve: {
        assignedRows: function () {
          return vm.module.rows
        },
        availableRows: function () {
          return vm.availableRows
        },
        moduleType: function () {
          return vm.module.moduleType
        }

      }
    }).result
      .then(
        function close (rows) {
          vm.module.rows = rows.assigned.map(row => new NetworkRow(row))
          vm.availableRows = rows.available.map(row => new NetworkRow(row))

          if (vm.module.rows.length && !vm.module.rows.map(row => row.$uuid).includes(vm.selectedRow?.$uuid)) {
            vm.selectedRow = vm.module.rows[0]
          }
          vm.invalidRows = !vm.module.rows.length
          vm.disabledByRows = false
        },
        function dismiss () {
          angular.copy(initialAssigned, vm.module.rows)
          angular.copy(initialAvailable, vm.availableRows)
          vm.disabledByRows = false
        })
  }

  vm.setIcon = function (icon) {
    vm.module.iconName = icon
  }

  vm.deleteRow = function (row) {
    vm.module.rows = vm.module.rows.filter(r => r.$uuid !== row.$uuid)
    vm.availableRows.push(row)
    if (row.sortOrder === vm.selectedRow.sortOrder) {
      if (row.sortOrder === 1) {
        vm.selectedRow = vm.module.rows[0]
      } else {
        vm.selectedRow = vm.module.rows[row.sortOrder - 2]
      }
    }
    vm.invalidRows = !vm.module.rows.length
    vm.disabledByRows = false
  }

  vm.changeRowInfo = function () {
    vm.disabledByRows = false
  }

  vm.changeRow = function (key, value) {
    vm.selectedRow[key] = value
    vm.disabledByRows = false
    scope.dispatchRow(vm.selectedRow)
  }

  vm.changeRowBackground = function (key, value) {
    vm.selectedRow.backgroundStyle[key] = value
    if (value === 'GRADIENT' && !vm.selectedRow.backgroundStyle.gradientConfig) {
      vm.choseBackgroundColors(0)
    }
    vm.disabledByRows = false
    scope.dispatchRow(vm.selectedRow)
  }

  vm.changeRowTop = function (value) {
    vm.selectedRow.top = value
    vm.disabledByRows = false
    scope.dispatchRow(vm.selectedRow)
  }

  vm.loadIcon = function (key) {
    if (key) {
      return require('../../img/icons/' + key + '.svg')
    } else {
      return ''
    }
  }

  vm.showVerticalPoster = function () {
    vm.onlyHoizontal = ['FEATURED_CHANNELS', 'FAVOURITE_CHANNELS', 'RECOMMENDED_CHANNELS', 'TV_SHOWS_EXTRA', 'VODS_EXTRA', 'CHANNELS_EXTRA', 'PARTNER_PRODUCTS', 'CHANNEL_CATEGORY', 'RECENTLY_WATCHED_CHANNELS', 'SHELF_WITH_CHANNELS']
    return !vm.onlyHoizontal.includes(vm.selectedRow?.type)
  }

  /**
   * Upload Image
   *
   * @memberOf mwApp/promotion.controller:PromotionCtrl
   * @param file
   * @function
   */
  vm.uploadImage = (file) => {
    // $scope.form.$setDirty()
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 16
      const heightPart = this.height / 9
      _URL.revokeObjectURL(objectUrl)
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alert('Aspect ratio must be 16:9', 'danger')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (file.size > 10485760) {
        alertLiteSvc.alert('File bigger than 10 MB', 'danger')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return upload(file, 'row_background').then((response) => {
        vm.selectedRow.backgroundStyle.imageUrl = response
        vm.disabledByRows = false
      }).finally(() => {
        $scope.$broadcast('dndfile.clear', true)
      })
    }
    img.src = objectUrl
  }

  /**
   * Base upload method
   *
   * @param file
   * @param {String} type
   * @returns {Promise}
   */
  function upload (file, type) {
    return vm.selectedRow._uploadFile(null, file, {
      type
    }).data()
  }

  /**
   * Delete background image
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @function
   */
  vm.deleteImage = () => {
    vm.selectedRow.backgroundStyle.imageUrl = null
    vm.disabledByRows = false
  }

  vm.gradients = [
    {
      colors: [{
        color: '#BB86FC',
        percentage: 0
      }, {
        color: '#331978',
        percentage: 100
      }],
      type: 'LINEAR',
      angle: 135.14
    },
    {
      colors: [{
        color: '#FB4BF0',
        percentage: 0
      }, {
        color: '#7268F8',
        percentage: 100
      }],
      type: 'LINEAR',
      angle: 135.14
    },
    {
      colors: [{
        color: '#00D2FF',
        percentage: 0
      }, {
        color: '#0058D1',
        percentage: 100
      }],
      type: 'LINEAR',
      angle: 135.14
    },
    {
      colors: [{
        color: '#00B036',
        percentage: 0
      }, {
        color: '#41ADD0',
        percentage: 100
      }],
      type: 'LINEAR',
      angle: 135.14
    },
    {
      colors: [{
        color: '#FFE500',
        percentage: 0
      },
      {
        color: '#FC3967',
        percentage: 100
      }],
      type: 'LINEAR',
      angle: 135.14
    },
    {
      colors: [{
        color: '#EE0979',
        percentage: 0
      }, {
        color: '#FF6A00',
        percentage: 100
      }],
      type: 'LINEAR',
      angle: 135.14
    }
  ]

  vm.choseBackgroundColors = function (index) {
    vm.selectedRow.backgroundStyle.gradientConfig = vm.gradients[index]
    vm.disabledByRows = false
    scope.dispatchRow(vm.selectedRow)
  }

  vm.chosenColors = function (index) {
    return vm.selectedRow.backgroundStyle?.gradientConfig?.colors.find(color => {
      return vm.gradients[index].colors.find(c => c.color === color.color)
    })
  }

  vm.linearGradient = (i) => {
    return `linear-gradient(${vm.gradients[i].angle}deg, ${vm.gradients[i].colors[0].color} ${vm.gradients[i].colors[0].percentage}%, ${vm.gradients[i].colors[1].color}  ${vm.gradients[i].colors[1].percentage}%)`
  }

  vm.selectRow = function (link) {
    if (vm.rowForm && vm.rowForm.$invalid) { return }
    vm.selectedRow = link
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddModuleSettingsCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(pckg._publicUrl + '/customization#moduleConfiguration')
    }
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onRowDrop = function (items, index) {
    // form.$setDirty()
    items.forEach(item => { item.selected = false })
    vm.module.rows = vm.module.rows
      .slice(0, index)
      .concat(items.map(item => new NetworkRow(item)))
      .concat(vm.module.rows.slice(index))
    vm.module.rows = vm.module.rows.filter(item => !item.selected)
    if (items.find(item => item.id === vm.selectedRow.id)) {
      vm.module.rows.forEach(item => {
        if (item.id === vm.selectedRow.id) {
          vm.selectedRow = item
        }
      })
    }
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    vm.disabledByRows = false
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  vm.showInfoAccordion = function (labels) {
    return ['DEFAULT', 'SHELF', 'EXTERNAL'].every(i => !labels?.includes(i))
  }

  vm.changeShelfTop = function (top) {
    vm.selectedRow.top = top

    if (top) {
      vm.changeRow('posterSize', 'M')
    }
    vm.disabledByRows = false
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list = list.filter(item => !item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => {
      item.selected = false
    })
    list.dragging = false
  }

  vm.isDisabledByRows = function () {
    return vm.form.$submitted && vm.disabledByRows
  }

  vm.isDisabledByIconName = function () {
    return vm.form.$submitted && !vm.module.iconName
  }

  vm.submit = function () {
    vm.form.$setSubmitted()
    vm.invalidRows = !vm.module.rows.length
    if (vm.form.$valid && vm.module.iconName) {
      vm.module._save(null, null, 'Module added', 'Module updated', function (err) {
        return err.data.includes('The number of assigned Rows')
      }).then(() => {
        $location.url(pckg._publicUrl + '/customization#moduleConfiguration')
      }).catch((err) => {
        if (err.data.includes('The number of assigned Rows')) {
          vm.rowError = err.data
          const splittedError = err.data.split(' ')
          const rowsRestrictions = []
          splittedError.forEach((err) => {
            if (!isNaN(err)) {
              rowsRestrictions.push(+err)
            }
          })
          vm.rowsMaxLength = rowsRestrictions[rowsRestrictions.length - 1]
          vm.invalidRows = true
        }
      })
    }
  }

  vm.disabledUpdate = function (form) {
    return (vm.disabledByRows && form.$pristine) || form.$invalid || vm.invalidRows
  }

  vm.delete = function () {
    vm.module._delete('Module deleted')
      .then(() => $location.url(pckg._publicUrl + '/customization#moduleConfiguration'))
  }

  $scope.$watch('vm.module.title', () => {
    if (vm.module.moduleType === 'KIDS') return

    vm.form.title.$setValidity('uniq', !assignedItems.title.includes(vm.module.title))
    vm.form.title.$setValidity('predefined', !vm.predefinedTitles.includes(vm.module.title))
  })

  $scope.$watch('vm.module.iconName', (newVal, oldVal) => {
    if (oldVal !== newVal) {
      vm.form.$setDirty()
    }
  })

  $scope.$watch('vm.module.identifier', () => {
    vm.form.identifier.$setValidity('uniq', !assignedItems.identifier.includes(vm.module.identifier))
    vm.form.identifier.$setValidity('predefined', !vm.predefinedIdentifiers.includes(vm.module.identifier))
  })

  $scope.$watch('vm.selectedRow', () => {
    if (Object.prototype.hasOwnProperty.call(scope, 'dispatchRow')) {
      scope.dispatchRow(vm.selectedRow)
    }
  })

  $scope.$watch('vm.module.rows', () => {
    if (vm.module.rows) {
      vm.module.rows.forEach((row, i) => {
        row.sortOrder = i + 1
      })
    }
    if (vm.rowsMaxLength) {
      vm.invalidRows = vm.module.rows.length === 0 || vm.module.rows.length > vm.rowsMaxLength
    }
  })
}
